<template lang="pug">
    .component-card-9
        .row
            .columns.shrink.align-self-middle(v-if="showBullets").show-for-medium
                slot(name="actionBullets")
            .columns
                .row
                    .columns.n1.large-2.small-12
                        slot(name="n1")
                    .columns.n2.align-self-middle.small-12.medium-6.large-2
                        slot(name="n2")
                    .columns.n3.align-self-middle.small-6.large-1
                        slot(name="n3")
                    .columns.n4.align-self-middle.small-6.large-1
                        slot(name="n4")
                    .columns.n5.align-self-middle.small-6.large-1
                        slot(name="n5")
                    .columns.n6.align-self-middle.large-1
                        slot(name="n6")
                    .columns.n7.align-self-middle.large-1
                        slot(name="n7")
                    .columns.n8.align-self-middle.small-12.large-1
                        slot(name="n8")
                    .columns.n9.align-self-middle.large-2
                        slot(name="n9")
            .columns.shrink.align-self-middle.show-for-medium(v-if="showAction")
                slot(name="actionPage")
</template>
<script type="text/babel">
    export default{
        name: "Card9",
        components: {
        },
        data(){
            return {}
        },
        created() {
        },
        methods: {
            actionClicked(){
                this.$emit('actionClicked')
            },
            bulletsClicked(){
                this.$emit('bulletsClicked')
            }
        },
        computed: {},
        props: ['showBullets', 'showAction']
    }
</script>

<style lang="sass" rel="stylesheet/sass">
    .action
        cursor: pointer
</style>


// WEBPACK FOOTER //
// Card9.vue?02d9a919